import React from 'react';

import Icon from 'components/shared/Icon';
import Down from 'components/shared/Icon/icons/Down';

import styles from './index.module.css';

function RoleBlock(props) {
  const { children, handleClick, disabled } = props;

  return (
    <button type="button" onClick={handleClick} className={styles.roleBtn} disabled={disabled}>
      {children}
      <Icon component={Down} height={14} width={7} />
    </button>
  );
}

export default RoleBlock;
